<template>
  <div class="filter">
    <div class="row g-2 g-md-3 g-lg-4">
      <div
        class="col-xl-3 col-lg-4 col-md-6"
        v-for="(item, index) in parameters"
        v-if="item.items.length"
        :key="index"
      >
        <AppFilterDropdown
          :name="item.name"
          :parametr="item.items"
          :selectOnChange="selectOnClick"
        />
      </div>
      <slot />
    </div>
    <div class="filter__info">
      <span
        >{{ foundLabel }}: <b>{{ cards.length }}</b></span
      >
    </div>
    <div class="row filter__results">
      <div
        class="col-lg-6 col-xl-4 align-self-start"
        v-for="(card, index) in cards"
        v-bind:key="index"
      >
        <AppFilterCards
          :id="index"
          :card="card"
          :moreLabel="learnMoreLabel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppFilterCards from "./AppFilterCards.vue";
import AppFilterDropdown from "./AppFilterDropdown.vue";
import AppFilterCards1 from "./AppFilterCards.vue";

import queryString from 'query-string';

export default {
  name: "AppFilter",
  components: {
    AppFilterCards,
    AppFilterDropdown,
    AppFilterCards1,
  },
  data() {
    return {
      selected: {},
      cards: [],
      parameters: [],
      pageUrl: '',
      additionalFilter: [],
      additionalFilterString: {},
      inputValues: {},
      apiUrl: 'api/v1/schools'
    };
  },
  props: {
    schoolTypes: {
      type: String,
      default: ''
    },
    activeFilters: {
      type: String,
      default: ''
    },
    learnMoreLabel: {
      type: String,
      default: 'Learn more'
    },
    foundLabel: {
      type: String,
      default: 'Found'
    },
  },
  methods: {
   async fetchData() {
    const parameters = queryString.stringify(this.selected, {arrayFormat: 'comma'});
    await fetch(`${this.pageUrl}${this.apiUrl}/?school_types=${this.schoolTypes}&shown_filters=${this.activeFilters}&additional_filter=${this.generateApiString()}&${parameters}`)
      .then((response) => response.json())
      .then((json) =>  {
        this.cards = json.data;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    },

    async initFetch() {
      await fetch(`${this.pageUrl}${this.apiUrl}/filters?school_types=${this.schoolTypes}&shown_filters=${this.activeFilters}`)
        .then((response) => response.json())
        .then((json) =>  {
          this.parameters = json.data.filter(x => x.id !== 'school_types');
          this.fetchData();
        });
    },

    selectedIds() {

      this.parameters.forEach(select => {
        const slug = select.id;

        const selectedItems = select.items.map(i => {
          if (i.children === undefined) {
            return i.selected === true ? i.id : undefined
          } else {
            return i.children.map(c => c.selected === true ? c.id : undefined)
          }
        });

        const finalSelectedItems = selectedItems.flat().filter(item => item !== undefined);

        this.selected = {...this.selected, [slug]: finalSelectedItems}
      });

    },

    selectOnClick(name, event, parentName) {
      const id = event.target.dataset.itemId;
      const sectionId = this.parameters.findIndex((e) => e.name === name) // --> 0
      const sectionParentId = this.parameters[sectionId].items.findIndex((e) => e.id == id);
      const sectionChildrens = this.parameters[sectionId].items[sectionParentId];

      if (sectionChildrens !== undefined) {
        sectionChildrens.selected = !sectionChildrens.selected;

        if (sectionChildrens.children !== undefined) {
          sectionChildrens.children.forEach(item => {
            item.selected = sectionChildrens.selected;
          });
        }
      } else {
        const parentChildrenIndex = this.parameters[sectionId].items.findIndex((e) => e.name === parentName)
        const subParent = this.parameters[sectionId].items[parentChildrenIndex];
        const subParentChildren = subParent.children;
        const subParentChildrenId = subParentChildren.findIndex((e) => e.id == id);
        subParentChildren[subParentChildrenId].selected = !subParentChildren[subParentChildrenId].selected;
        const target = document.querySelector(`input[data-item-id='${subParent.id}']`)
        const selectedChildrens = subParentChildren.filter(i => i.selected === true);
        const childrenLength = subParentChildren.length;
        const selectedChildrensLength = selectedChildrens.length;

        if (selectedChildrensLength === 0) {
          target.indeterminate = false;
          this.parameters[sectionId].items[parentChildrenIndex].selected = false;
        } else if (childrenLength === selectedChildrensLength) {
          target.indeterminate = false;
          // console.log(this.parameters[sectionId].items[parentChildrenIndex]);
          this.parameters[sectionId].items[parentChildrenIndex].selected = true;
        } else {
          target.indeterminate = true;
        }
      }

        this.selectedIds()
        this.fetchData()
    },

    initAdditionalFilter() {
      const inputs = document.querySelectorAll('.js--form-additional-filter');

      if (inputs && inputs.length) {
        Array.from(inputs).forEach(input => {
          // Při inicializaci uložíme všechny hodnoty do inputValues
          this.inputValues[input.name] = input.checked;

          input.addEventListener('change', () => {
            this.updateInputValues(inputs);
            this.fetchData();
            // this.additionalFilterString = this.generateApiString();
            // console.log(this.additionalFilterString);
          });
        });
      }
    },

    updateInputValues(inputs) {
      inputs.forEach(input => {
        this.inputValues[input.name] = input.checked;
      });
    },

    generateApiString() {
      return Object.entries(this.inputValues).map(([key, value]) => `${key}=${value}`).join(',');
    },
  },
  mounted () {
    this.initAdditionalFilter();
    // this.pageUrl = 'https://jkeducation.com/expo-guide-universities/'
    this.pageUrl = window.location.href.split('?')[0];
    this.initFetch();
  }
};
</script>
